import { useEffect, useRef } from 'react'
import { Typography, Stack, Button, Box } from '@mui/material'
import apiBaseUrl from '../../io/api/baseUrl'
import Center from '../../components/layout/Center'

const SignInPage = () => {
  const hasOpenedTab = useRef(false)

  const downloadUrl = `${apiBaseUrl}updates/latest-eidu-field?type=support`

  const openDownloadUrl = () => {
    window.open(downloadUrl, '_blank')
  }

  useEffect(() => {
    if (!hasOpenedTab.current) {
      openDownloadUrl()
      hasOpenedTab.current = true
    }
  }, [])

  return (
    <Center sx={{ height: '100vh' }}>
      <Stack spacing={4} alignItems="center">
        <img src="/logoGreen.png" alt="EIDU Logo" width="240" />
        <Box
          sx={{
            width: '50%',
            height: '4px',
            background: 'linear-gradient(90deg, transparent, #003223, transparent)',
            my: 3,
          }}
        />
        <Typography variant="h5" align="center">
          Downloading Field App in new tab
        </Typography>
        <Typography variant="body1" color="text.secondary" align="center">
          If the download did not start automatically, please{' '}
          <Button
            onClick={openDownloadUrl}
            color="primary"
            sx={{ fontWeight: 'bold', minWidth: 'auto', padding: '0 4px' }}
          >
            click here
          </Button>
          .
        </Typography>
      </Stack>
    </Center>
  )
}

export default SignInPage
